import {
  JobSupport3fdjh0rbee4be as JobSupport,
  get_COMPLETING_WAITING_CHILDREN3nnjgv5wv89p1 as get_COMPLETING_WAITING_CHILDREN,
} from './JobSupport.mjs';
import {
  Key_instancebefxze3q9f64 as Key_instance,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from './Debug.mjs';
import {
  CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally,
  toState1lqvgl5d0bogr as toState,
} from './CompletionState.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from './CoroutineExceptionHandler.mjs';
import { get_coroutineName3a0vy840b4l1i as get_coroutineName } from './CoroutineContext.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractCoroutineClass;
function AbstractCoroutine() {
  if (AbstractCoroutineClass === VOID) {
    class $ extends JobSupport() {
      constructor(parentContext, initParentJob, active) {
        super(active);
        if (initParentJob) {
          this.yv(parentContext.bd(Key_instance));
        }
        this.bw_1 = parentContext.qm(this);
      }
      pc() {
        return this.bw_1;
      }
      cw() {
        return this.bw_1;
      }
      dw() {
        return super.dw();
      }
      ew(value) {
      }
      fw(cause, handled) {
      }
      gw() {
        return get_classSimpleName(this) + ' was cancelled';
      }
      hw(state) {
        if (state instanceof CompletedExceptionally()) {
          this.fw(state.iw_1, state.kw());
        } else {
          this.ew(state);
        }
      }
      rc(result) {
        var state = this.lw(toState(result));
        if (state === get_COMPLETING_WAITING_CHILDREN())
          return Unit_instance;
        this.mw(state);
      }
      mw(state) {
        return this.nw(state);
      }
      ow(exception) {
        handleCoroutineException(this.bw_1, exception);
      }
      pw() {
        var tmp0_elvis_lhs = get_coroutineName(this.bw_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return super.pw();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var coroutineName = tmp;
        return '"' + coroutineName + '":' + super.pw();
      }
      qw(start, receiver, block) {
        start.tw(block, receiver, this);
      }
    }
    initMetadataForClass($, 'AbstractCoroutine', VOID, VOID, [Job(), Continuation()], [0]);
    AbstractCoroutineClass = $;
  }
  return AbstractCoroutineClass;
}
//region block: exports
export {
  AbstractCoroutine as AbstractCoroutine2jzyhqo91sb0o,
};
//endregion

//# sourceMappingURL=AbstractCoroutine.mjs.map
